import { useTranslation } from "react-i18next";
import { UploadFileButton } from "../../../../../../common/Components/Buttons/UploadFileButton";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { TUploadFileMethod } from "../../../../types";
import styles from "./styles.module.css";

interface Props {
  uploadFileMethod: TUploadFileMethod;
  handleClick: (type: TUploadFileMethod) => void;
  handleFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactElement;
  isOpen: boolean;
}

export const UploadFIleModalAction = ({
  uploadFileMethod,
  handleClick,
  handleFileUpload,
  children,
  isOpen,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles["action-wrapper"]}>
      {uploadFileMethod === "url" && (
        <AppButton buttonType={"outlined"} onClick={() => handleClick("url")}>
          {t("userfiles.add_file_by_url_btn")}
        </AppButton>
      )}
      {uploadFileMethod === "binary" && (
        <UploadFileButton
          title={t("userfiles.upload_file_from_pc")}
          type={"button"}
          styleType={"outlined"}
          multiple={true}
          handleFileUpload={(e) => {
            handleFileUpload(e);
            handleClick("binary");
          }}
          icon={null}
        />
      )}
      {isOpen && children}
    </div>
  );
};
